import React from 'react';
import { Link } from 'react-router-dom';
import { ORG_NAME, ROUTES, APP_NAME, APP_DESCRIPTION } from '@utils/constants';
import dmclLogo from '@assets/logos/dmcl-logo.jpg';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-ncaa-dark text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 className="text-lg font-semibold mb-4">{APP_NAME}</h3>
            <p className="text-gray-300 mb-4">
              {APP_DESCRIPTION}
            </p>
            <p className="text-sm text-gray-400">
              Streamlining aviation professional certification for a safer sky.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-md font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to={ROUTES.ABOUT}
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  About NCAA
                </Link>
              </li>
              <li>
                <Link
                  to={ROUTES.REQUIREMENTS}
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Requirements
                </Link>
              </li>
              <li>
                <Link
                  to={ROUTES.CENTERS}
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Capture Centers{' '}
                </Link>
              </li>
              <li>
                <Link
                  to={ROUTES.CONTACT}
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Contact Support
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-md font-semibold mb-4">Support</h4>
            <ul className="space-y-2">
              <li>
                <span className="text-gray-300">Help Center</span>
              </li>
              <li>
                <span className="text-gray-300">Documentation</span>
              </li>
              <li>
                <span className="text-gray-300">Privacy Policy</span>
              </li>
              <li>
                <span className="text-gray-300">Terms of Service</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-600 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {currentYear} {ORG_NAME}. All rights reserved.
          </p>
          <div className="flex items-center gap-2">
            <p className="text-gray-400 text-sm flex items-center gap-1">
              DCEV<sup className="text-xs">™</sup> powered by DMCL
            </p>
            <img
              src={dmclLogo}
              alt="DMCL Logo"
              className="h-5 w-5 object-contain"
              title="Debbie Misheal Consulting Limited"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};
